//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "HAD",
  data() {
    return {
      form: {
        nervous: "",
        hobby: "",
        fear: "",
        smile: "",
        worried:"",
        happiness:"",
        releax:"",
        slow:"",
        afraidOfDiscomfort:"",
        appearance:"",
        somaticAnxiety:"",
        expectation:"",
        panic:'',
        enjoyTheProgram:"",
        
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "3", name: "大多数时候" },
        { value: "2", name: "很多时候" },
        { value: "1", name: "偶尔" },
        { value: "0", name: "根本没有" },
      ],
      dataList2: [
        { value: "0", name: "绝对一样多" },
        { value: "1", name: "不像以前那么多" },
        { value: "2", name: "只有一点" },
        { value: "3", name: "根本没有" },
      ],
      dataList3: [
        { value: "3", name: "非常肯定" },
        { value: "2", name: "有，但不是非常糟糕；" },
        { value: "1", name: "有，但并不让我担心" },
        { value: "0", name: "根本没有" },
      ],
      dataList4: [
        { value: "0", name: "和以前一样；" },
        { value: "1", name: "现在不是那么多；" },
        { value: "2", name: "现在肯定不是那么多；" },
        { value: "3", name: "根本没有" },
      ],
      dataList5: [
        { value: "3", name: "很多时候" },
        { value: "2", name: "有时候，不太频繁；" },
        { value: "1", name: "只有偶尔" },
        { value: "0", name: "根本没有" },
      ],
      dataList6: [
        { value: "0", name: "根本没有" },
        { value: "1", name: "并不经常" },
        { value: "2", name: "有时" },
        { value: "3", name: "大多数" },
      ],
      dataList7: [
        { value: "3", name: "当然" },
        { value: "2", name: "经常" },
        { value: "1", name: "不经常" },
        { value: "0", name: "根本没有" },
      ],
      dataList8: [
        { value: "0", name: "几乎所有的时间" },
        { value: "1", name: "经常" },
        { value: "2", name: "有时候" },
        { value: "3", name: "根本没有" },
      ],
      dataList9: [
        { value: "3", name: "根本没有" },
        { value: "2", name: "偶尔" },
        { value: "1", name: "经常" },
        { value: "0", name: "非常频繁" },
      ],
      dataList10: [
        { value: "0", name: "肯定" },
        { value: "1", name: "经常" },
        { value: "2", name: "偶尔" },
        { value: "3", name: "我还是很在意 " },
      ],
      dataList11: [
        { value: "3", name: "确实相当多" },
        { value: "2", name: "有点多" },
        { value: "1", name: "并不多" },
        { value: "0", name: "根本没有 " },
      ],
      dataList12: [
        { value: "0", name: "和以前一样多" },
        { value: "1", name: "比以前少" },
        { value: "2", name: "比以前少多了" },
        { value: "3", name: "根本没有" },
      ],
      dataList13: [
        { value: "3", name: "确实经常" },
        { value: "2", name: "有时" },
        { value: "1", name: "偶尔" },
        { value: "0 ", name: "根本没有" },
      ],
      dataList14: [
        { value: "0", name: "经常" },
        { value: "1", name: "有时" },
        { value: "2", name: "偶尔" },
        { value: "3", name: "根本没有" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/HAD.vue